module.exports = __webpack_public_path__ + "static/media/with-wireless-chager.67cb5f3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/airpods/with-wireless-chager.png
// module id = 1140
// module chunks = 0